import { getEnv } from '@adsk/acs-sc-web-platform-api';

import { ENV_CONFIGS } from '../consts';

export function getConfig(key: string): string {
  const env = getEnv();
  const val = ENV_CONFIGS?.[env]?.[key];

  if (!val) {
    throw new Error(
      `[SubmittalsReferencePickerPlugin] - Cannot find env config for env: ${env}, and key: ${key}`,
    );
  }

  return val;
}
